// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface UserMessageRequestDto
 */
export interface UserMessageRequestDto {
    /**
     *
     * @type {string}
     * @memberof UserMessageRequestDto
     */
    messageText: string;
    /**
     *
     * @type {string}
     * @memberof UserMessageRequestDto
     */
    emailAddress?: string;
}

/**
 * Check if a given object implements the UserMessageRequestDto interface.
 */
export function instanceOfUserMessageRequestDto(value: object): value is UserMessageRequestDto {
    if (!('messageText' in value) || value['messageText'] === undefined) return false;
    return true;
}

export function UserMessageRequestDtoFromJSON(json: any): UserMessageRequestDto {
    return UserMessageRequestDtoFromJSONTyped(json, false);
}

export function UserMessageRequestDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserMessageRequestDto {
    if (json == null) {
        return json;
    }
    return {
        messageText: json['messageText'],
        emailAddress: json['emailAddress'] == null ? undefined : json['emailAddress'],
    };
}

export function UserMessageRequestDtoToJSON(value?: UserMessageRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        messageText: value['messageText'],
        emailAddress: value['emailAddress'],
    };
}
